import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MdCheckboxModule} from '@angular/material';
import {CustomFormsModule} from 'ng2-validation';
import {PipeModule} from '../../pipe/pipe.module';
import {AddressModule} from '../address/address.module';
import {BillingAccountModule} from '../billing-account/billing-account.module';
import {OrgRepComponent} from './org-rep.component';

@NgModule({
  imports: [AddressModule, BillingAccountModule, CommonModule, CustomFormsModule, FormsModule, MdCheckboxModule, PipeModule],
  declarations: [OrgRepComponent],
  exports: [OrgRepComponent],
})
export class OrgRepModule {}



// WEBPACK FOOTER //
// ./src/app/shared/ui/org-rep/org-rep.module.ts